import React, { useState, useEffect } from "react";
import View from 'src/components/view';
import utils from "src/components/utils";

const BlogAmericaLatina = function () {
  let url_blog = utils.lng('url_blog','https://blog-internacional.nipponflex.com/');

  return (
    <View styleClass="ui-full-page" name="blog" style={{backgroud: '#000'}}>
       <iframe src={url_blog}  style={{border: 'none',width: '100%', height: '100%'}}></iframe>
    </View>
  );
}

export default BlogAmericaLatina;